import { render, staticRenderFns } from "./HealthCheck35PsaThyroidNR.vue?vue&type=template&id=38ebba49&scoped=true&"
import script from "./HealthCheck35PsaThyroidNR.vue?vue&type=script&lang=js&"
export * from "./HealthCheck35PsaThyroidNR.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck35PsaThyroidNR.vue?vue&type=style&index=0&id=38ebba49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ebba49",
  null
  
)

export default component.exports